// required: npm i skeletabs --save
// https://findawayer.github.io/skeletabs/
// A Taste nicht verwenden siehe skelettabs Zeile  966
S.projectfiltertabs =
    {
        config: {
            breakpoint: 1024,
            // continent__4;continent__2;branche__1;
            defaultvalues: '',
        },

        elements: {
            $tabsContainer: null,
            $panelGroup: null,
            $filterinit: null,
            $filterActive: null,
        },
        resetParam: false,

        init()
        {
            this.setDefault();
            this.resetFilter();
            this.cancelFilter();
            this.startFilter();
            this.setFilter();
            this.slideFilter();
            this.initTab();
        },

        hideElement(item, showIds, type, search)
        {
            $.each((showIds), (c, x) =>
            {
                const str = x + ',';
                const found = type.indexOf(str);

                // nur in Bereich search & id kommt NICHT vor
                if (x.indexOf(search) !== -1 && found === -1)
                {
                    // console.log(x);
                    $(item).addClass('is-hidden');
                }
            });
        },

        showElement(item, showIds, type, search)
        {
            $.each((showIds), (c, x) =>
            {
                const str = x + ',';
                const found = type.indexOf(str);

                // nur continent_ & id kommt vor
                if (x.indexOf(search) !== -1 && found !== -1)
                {
                    // console.log(x);
                    $(item).removeClass('is-hidden');
                }
            });
        },

        // nur wenn keines der gewählten Checkboxen macht nicht anzeigen
        checkElement(item, showIds, type, search)
        {
            let show = false;

            $.each((showIds), (c, x) =>
            {
                const str = x + ',';
                const found = type.indexOf(str);

                // nur in Bereich search & id kommt vor
                if (x.indexOf(search) !== -1 && found !== -1)
                {
                    show = true;
                }
            });

            // Kachel wir bereits angezeigt ausgewählte Optionen kommt aber kein einziges vor
            if (!$(item).hasClass('is-hidden') && show === false)
            {
                $(item).addClass('is-hidden');
            }
        },

        showTeaser(showIds, ids)
        {
            let setRegion = false;
            let setTopic = false;
            let setCommodity = false;
            let setPhase = false;
            let setArchive = false;

            // loop all elements
            $.each(($('.mod-projects').find('.js-teaser')), (index, item) =>
            {
                const type = $(item).attr('data-type');

                if (showIds.length > 0)
                {
                    $(item).addClass('is-hidden');
                }
                else
                {
                    $(item).removeClass('is-hidden');
                }

                // continent kommt im suchstring vor
                if (ids.indexOf('country_') !== -1)
                {
                    setRegion = true;

                    this.showElement(item, showIds, type, 'country_');
                }

                if (ids.indexOf('topic_') !== -1)
                {
                    setTopic = true;

                    if (setRegion === true)
                    {
                        // wenn Kachel schon show hat, dann reicht es wenn ein gewähltes von branche vorhanden ist (ODER)
                        this.checkElement(item, showIds, type, 'topic_');
                    }
                    else
                    {
                        this.showElement(item, showIds, type, 'topic_');
                    }
                }

                if (ids.indexOf('commodity_') !== -1)
                {
                    setCommodity = true;

                    if (setTopic === true || setRegion === true)
                    {
                        // wenn Kachel schon show hat, dann reicht es wenn ein gewähltes von branche vorhanden ist (ODER)
                        this.checkElement(item, showIds, type, 'commodity_');
                    }
                    else
                    {
                        this.showElement(item, showIds, type, 'commodity_');
                    }
                }

                if (ids.indexOf('phase_') !== -1)
                {
                    setPhase = true;

                    if (setTopic === true || setRegion === true || setCommodity === true)
                    {
                        // wenn Kachel schon show hat, dann reicht es wenn ein gewähltes von branche vorhanden ist (ODER)
                        this.checkElement(item, showIds, type, 'phase_');
                    }
                    else
                    {
                        this.showElement(item, showIds, type, 'phase_');
                    }
                }

                if (ids.indexOf('archiv_') !== -1)
                {

                    if (setTopic === true || setRegion === true || setCommodity === true || setPhase === true)
                    {
                        // wenn Kachel schon show hat, dann reicht es wenn ein gewähltes von branche vorhanden ist (ODER)
                        this.checkElement(item, showIds, type, 'archiv_');
                    }
                    else
                    {
                        this.showElement(item, showIds, type, 'archiv_');
                    }
                }
            });
        },

        filter()
        {
            // let allIds = '';
            const showIds = [];
            let ids = '';

            $.each((this.elements.$panelGroup.find('input')), (index, item) =>
            {
                const id = $(item).attr('id');
                const filterId = 'filter_' + id;

                if (item.checked === true)
                {
                    // console.log(id);
                    // allIds += id + ',';
                    $('#' + filterId).removeClass('m-check');
                    // Search Ids sammeln als array
                    showIds.push(id);
                    // Search Ids sammeln als string
                    ids += id + ',';
                }
            });

            $('#start_filter').prop('disabled', true);

            sessionStorage.setItem('setfilter', JSON.stringify(showIds));

            this.showTeaser(showIds, ids);
        },

        showFilterStatus()
        {
            $('#filter_status').html($('.m-filter-active').html());

            if (this.elements.$tabsContainer.hasClass('is-open'))
            {
                $('#filter_status').addClass('is-hidden');
            }
            else
            {
                $('#filter_status').removeClass('is-hidden');
            }
        },

        doDefaultFilter()
        {
            $('#start_filter').prop('disabled', false);

            setTimeout(() =>
            {
                $('#start_filter').click();
            }, 120);

            setTimeout(() =>
            {
                this.showFilterStatus();
            }, 160);
        },

        setDefault()
        {
            let myArray = [];
            let def = false;
            const defaultval = this.config.defaultvalues.replace(/;/g, ',');

            if (defaultval === '')
            {
                // sessionStorage Werte vorhanden?
                // const storage = 'branche__1,';
                // myArray = storage.split(',');
                myArray = JSON.parse(sessionStorage.getItem('setfilter'));
            }
            else
            {
                // console.log(defaultval);
                myArray = defaultval.split(',');
            }

            setTimeout(() =>
            {
                $.each((myArray), (index, item) =>
                {
                    if (item !== '')
                    {
                        $('#' + item).click();

                        // workaround on browser back click wont trigger so check if click trigger if not triger again
                        if ($('#' + item).is(':checked') === false)
                        {
                            $('#' + item).click();
                        }

                        def = true;
                    }
                });
            }, 40);

            setTimeout(() =>
            {
                if (def === true)
                {
                    this.doDefaultFilter();
                }
            }, 80);
        },

        removeFilter(id)
        {
            $('#' + id).remove();
        },

        resetFilter()
        {
            $('#reset_filter').on('click', () =>
            {
                $.each((this.elements.$panelGroup.find('input')), (index, item) =>
                {
                    if (item.checked === true)
                    {
                        item.click();
                    }
                });

                $('#reset_filter').hide();
            });
        },

        cancelFilter()
        {
            $('#cancel_filter').on('click', () =>
            {
                $.each((this.elements.$filterActive.find('button')), (index, item) =>
                {
                    if ($(item).hasClass('m-check'))
                    {
                        const filterId = $(item).attr('id').replace('filter_', '');

                        $('#' + filterId).click();
                    }
                });

                $('#start_filter').prop('disabled', true);

                this.elements.$filterinit.click();
            });
        },

        startFilter()
        {
            $('#start_filter').on('click', () =>
            {
                // remove parameter only on click not on init
                if (this.resetParam)
                {
                    S.removeparam.init();
                }
                this.resetParam = true;

                $('#layer-load').addClass('is-show');

                setTimeout(() =>
                {
                    this.filter();
                }, 250);

                setTimeout(() =>
                {
                    $('#layer-load').removeClass('is-show');
                }, 900);
            });
        },

        setFilter()
        {
            this.elements.$panelGroup.find('input').on('click', (e) =>
            {
                const id = e.currentTarget.id;
                const filterId = 'filter_' + id;
                const txt = $(e.currentTarget).next('label').html();
                // console.log(e.currentTarget.checked);

                $('#start_filter').prop('disabled', false);

                if (e.currentTarget.checked === true)
                {
                    const $button = $('<button class="m-button m-check" type="button" id="' + filterId + '">' + txt + '</button>');

                    // this.elements.$filterActive.append($button);
                    $button.appendTo(this.elements.$filterActive);
                    $button.on('click', () =>
                    {
                        const filterId = $button.attr('id').replace('filter_', '');

                        // alert($button.attr('id'));
                        $('#' + filterId).click();
                    });

                    $('#reset_filter').show();
                }
                else
                {
                    this.removeFilter(filterId);
                }
            });
        },

        slideFilter()
        {
            this.elements.$filterinit.on('click', () =>
            {
                this.elements.$tabsContainer.slideToggle(400);
                this.elements.$tabsContainer.toggleClass('is-open');
                this.elements.$filterinit.toggleClass('is-open');
                this.showFilterStatus();
            });
        },

        initTab()
        {
            // https://findawayer.github.io/skeletabs/#Options
            this.elements.$tabsContainer.skeletabs({
                breakpoint: this.config.breakpoint,
                // 'auto' | 'equal' | 'adaptive'
                // panelHeight: 'auto',
            });
        },
    };
